import React, { createContext, useContext, useState } from "react";
import { GetCartData, updateCartData } from "../api/DamApi";
import { message } from "antd";
import { useMutation, useQuery } from "@tanstack/react-query";
import { userSession } from "../constants/UserConstant";
import PropTypes from "prop-types";
const userData = userSession.userData;

// Create Cart Context
const CartContext = createContext();

// Custom hook to use the Cart Context


export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
    const [cart, setCart] = useState([]);
    const [saveCart, setSaveCart] = useState([]);

    const { isFetching: isShowCartData, refetch: refetchCartData } = useQuery({
        queryKey: ["ShowCartData"],
        queryFn: () => GetCartData(),
        select: (response) => response.data?.ResultSet,
        enabled: !!userData?.CLIENTID,
        onSuccess: (response) => {
            const cartData = response?.cartdt || [];
            setCart(cartData);
            setSaveCart(response?.savecart || []); // Ensure saveCart is an array
        }
    });

    const { mutate: updateCart, isLoading: isUpdating } = useMutation({
        mutationFn: (product) => updateCartData(product),
        onSuccess: (response, product) => {
            
            let resData = response?.data?.ResultSet;
            if (resData == 1) {
                const isInCart = cart.some((item) => item.PARAMCODE === product?.cart?.PARAMCODE);
                const updatedCart = isInCart
                    ? cart.filter((item) => item.PARAMCODE !== product?.cart?.PARAMCODE)
                    : [...cart, product.cart];
                setCart(Array.isArray(updatedCart) ? updatedCart : cart);
            }
        },
        onError: () => {
            message.error("Failed to update cart");
        },
    });

    const toggleCartItem = (product, flag) => {
        updateCart({ cart: product, flag });
    };

    return (
        <CartContext.Provider value={{ cart, toggleCartItem, isUpdating, saveCart, isShowCartData, setCart, refetchCartData }}>
            {children}
        </CartContext.Provider>
    );
};
CartProvider.propTypes = {
    children: PropTypes.node.isRequired,
};